var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"text-muted d-block mb-2"},[_vm._v("Chart")]),(_vm.$store.state.candlestick_loading)?_c('div',{staticClass:"card-bwfs p-2"},[_c('b-skeleton-img',{attrs:{"no-aspect":"","height":"200px"}})],1):_c('div',{staticClass:"chart-wrapper card-bwfs p-2 mb-4"},[_c('div',{staticClass:"chart",attrs:{"id":"container"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }